
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsBizTypesDialog extends Serenity.EntityDialog<PsBizTypesRow, any> {
        protected getFormKey() { return PsBizTypesForm.formKey; }
        protected getIdProperty() { return PsBizTypesRow.idProperty; }
        protected getLocalTextPrefix() { return PsBizTypesRow.localTextPrefix; }
        protected getNameProperty() { return PsBizTypesRow.nameProperty; }
        protected getService() { return PsBizTypesService.baseUrl; }
        protected getDeletePermission() { return PsBizTypesRow.deletePermission; }
        protected getInsertPermission() { return PsBizTypesRow.insertPermission; }
        protected getUpdatePermission() { return PsBizTypesRow.updatePermission; }

        protected form = new PsBizTypesForm(this.idPrefix);

    }
}